import { Box, Typography, useTheme } from '@mui/material';

interface DefaultSettingDetailProps {
  tabValue: number;
}

export const DefaultSettingDetail = ({
  tabValue,
}: DefaultSettingDetailProps) => {
  const theme = useTheme();

  const getMessage = () => {
    switch (tabValue) {
      case 0:
        return 'Profile settings are read-only in this version.';
      case 1:
        return 'Forms or other information related to the selected link on the left will be displayed here.';
      case 2:
        return 'Select a notification setting to configure.';
      default:
        return 'Select a setting to configure.';
    }
  };

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100%',
        backgroundColor: theme.palette.divider,
        p: 2,
        textAlign: 'center',
        borderRadius: '6px',
      }}
    >
      <Typography variant="body1">{getMessage()}</Typography>
    </Box>
  );
};
